import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Booking from "@/pages/booking";
import Contact from "@/pages/contact";
import { Home } from "@/pages/home";
import Layout from "@/pages/layout";
import { NotFound } from "@/pages/not-found";
import Order from "@/pages/order";

import { Providers } from "./providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/order" element={<Order />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
